<div class="estate-section" [class.details]="showDetails">
    <div class="estate-header-row">
        <div class="flex-pair">
            <div class="symbol" [class]="estateStat().name.toLowerCase()"></div>
            <div>{{ estateStat().namePlural }}</div>
        </div>
        <div class="estate-count">{{ estateStat().numberOfEstates | thousandize }}</div>
        <div class="estate-expand" [class.expanded]="showDetails" (click)="showDetails = !showDetails">

        </div>
    </div>
    @if (searchViewOptions().periodDefinitionType !== periodType.Sold) {
    <div>
        <statistics-priceassumption [statistics]="estateStat()" [showDetails]="showDetails" [isHeader]="false" [searchViewOptions]="searchViewOptions()"></statistics-priceassumption>
        @if (showDetails) {
        <div>
            <statistics-sold [statistics]="estateStat()" [showDetails]="showDetails" [isHeader]="false" [searchViewOptions]="searchViewOptions()"></statistics-sold>
        </div>
        }
    </div>
    } @if (searchViewOptions().periodDefinitionType === periodType.Sold) {
    <div>
        <statistics-sold [statistics]="estateStat()" [showDetails]="showDetails" [isHeader]="false" [searchViewOptions]="searchViewOptions()"></statistics-sold>
        @if (showDetails) {
        <div>
            <statistics-priceassumption [statistics]="estateStat()" [showDetails]="showDetails" [isHeader]="false" [searchViewOptions]="searchViewOptions()"></statistics-priceassumption>
        </div>
        }
    </div>
    }
</div>